import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

const lazyBrowseLayout = async () => ({
  Component: (await import(
    /* webpackChunkName: 'browse' */
    '../components/browse/browse_layout'
  )).default,
});

export const BrowsePageRoutes = [
  <Route
    key="cat/*"
    path="cat/*"
    handle={{ clientSide: true }}
    lazy={lazyBrowseLayout}
  />,
  <Route
    key="b/*"
    path="b/*"
    handle={{ clientSide: true }}
    lazy={lazyBrowseLayout}
  />,
  <Route
    key="m/*"
    path="m/*"
    handle={{ clientSide: true }}
    lazy={lazyBrowseLayout}
  />,
];
